angular.module('ikeweb.unit').filter('length', ['measurementFormatterService',
    function(measurementFormatterService) {

        function length(value) {
            return measurementFormatterService.format((value || 0));
        }
        length.$stateful = true;

        return length;
    }
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/unit/filters/length.filter.js
// module id = 443
// module chunks = 0